const HEADING_LEVELS = [1, 2, 3, 4, 5, 6];

export { HEADING_LEVELS as H };
